export const INVOICES_URL = '/app/invoices';
export const INVOICES_LIST_URL = '/app/invoices/list';
